import Script from "next/script";

const CustomScripts = () => {
  return (
    <>
      <Script
        strategy="lazyOnload"
        src="https://designs.hubtel.com/v3/app/dist/scripts/jquery.js"
      />
      {/* this handles the animation for navbar */}
      <Script
        strategy="afterInteractive"
        src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"
      />
      <Script
        strategy="lazyOnload"
        src="https://designs.hubtel.com/v3/app/dist/scripts/main.js"
      />
      <Script
        strategy="lazyOnload"
        defer
        src="https://static.cloudflareinsights.com/beacon.min.js/v652eace1692a40cfa3763df669d7439c1639079717194"
        integrity="sha512-Gi7xpJR8tSkrpF7aordPZQlW2DLtzUlZcumS8dMQjwDHEnw9I7ZLyiOj/6tZStRBGtGgN6ceN6cMH8z7etPGlw=="
        data-cf-beacon='{"rayId":"6d6209a9ba3072b5","token":"5f4f22e669d54423a93b2e43037c9d74","version":"2021.12.0","si":100}'
        crossOrigin="anonymous"
      />
      <Script
        strategy="lazyOnload"
        data-cfasync="false"
        src="/cdn-cgi/scripts/5c5dd728/cloudflare-static/email-decode.min.js"
      />
    </>
  );
};

export default CustomScripts;
